var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoarrows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 31,
    viewBox: "0 0 148 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7022 1.70717C31.0926 1.31661 31.0926 0.683389 30.7022 0.29283C30.3117 -0.0977294 29.6786 -0.0977294 29.2881 0.29283L30.7022 1.70717ZM0.000403744 30C0.000405346 30.5523 0.44808 31.0001 1.00031 31.0001L9.99951 31.0001C10.5517 31.0001 10.9994 30.5523 10.9994 30C10.9994 29.4477 10.5517 28.9999 9.99951 28.9999L2.00023 28.9999L2.00023 20.9992C2.00023 20.4469 1.55255 19.9991 1.00031 19.9991C0.448078 19.9991 0.000404208 20.4469 0.000403196 20.9992L0.000403744 30ZM29.2881 0.29283L0.293271 29.2928L1.70736 30.7072L30.7022 1.70717L29.2881 0.29283Z",
    fill: "#C53EAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.298 1.70706C116.907 1.31656 116.907 0.683436 117.298 0.292935C117.688 -0.0975662 118.321 -0.0975662 118.712 0.292935L117.298 1.70706ZM148.004 29.9957C148.004 30.5479 147.556 30.9956 147.004 30.9956L138.003 30.9956C137.451 30.9956 137.003 30.5479 137.003 29.9957C137.003 29.4434 137.451 28.9957 138.003 28.9957L146.004 28.9957L146.004 20.9962C146.004 20.444 146.452 19.9963 147.004 19.9963C147.556 19.9963 148.004 20.444 148.004 20.9962L148.004 29.9957ZM118.712 0.292935L147.711 29.2886L146.297 30.7028L117.298 1.70706L118.712 0.292935Z",
    fill: "#C53EAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoarrows);
export default __webpack_public_path__ + "static/media/twoarrows.71db89ba07a7bfa3af412685d68326ce.svg";
export { ForwardRef as ReactComponent };